export default __webpack_public_path__ + "static/media/help_blue.c07b5813.svg";